import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import FAQForm from "./components/FAQForm";
import { FaqInput, FaqInputError } from "../state/actionType";
import { connect, useSelector } from "react-redux";
import { createFaq } from "../state/action";
import { ApiError } from "components";

interface HandlerCreateFAQProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & HandlerCreateFAQProps;
const HandlerCreateFAQ: React.FC<Props> = ({ closeModal, onCreateFaq }) => {
  const faqState = useSelector((state: any) => state.faq.genericFaqState);
  const [formData, setFormData] = useState<FaqInput>({
    question: "",
    answer: "",
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<FaqInputError>({});
  const [apiError, setApiError] = useState(null);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (formData.answer.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        name: "Answer is required",
      }));
    }

    if (formData.question.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        description: "Question is required",
      }));
    }

    if (formData.answer.trim() !== "" && formData.question.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      try {
        await onCreateFaq(formData);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!faqState.isLoading && submitted) {
      if (faqState.error) {
        setApiError(faqState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [faqState.isLoading, faqState.error, submitted]);
  return (
    <>
      <FAQForm
        handleChange={handleChange}
        handleSave={handleSave}
        loading={loading}
        error={error}
        formData={formData}
        header="Create FAQ"
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateFaq: (input: FaqInput) => dispatch(createFaq(input)),
});
export default connect(null, mapDispatchToProps)(HandlerCreateFAQ);
